import classNames from "classnames";
import React, { useMemo, useState } from "react";
import { Content, LikesData } from "../globalType";
import { displayDuration, displayNumber, getContentUrl, share } from "../utils";
import {CopyToClipboard} from 'react-copy-to-clipboard'

declare var $: any;

type Props = {
  popup: Content | null;
  goToPage: (page: string, content: Content | null) => void;
  likes: (contentId: string | undefined) => void;
  likesData: LikesData | null;
};

export function Popup(props:Props) {
  const {goToPage, popup, likes, likesData} = props

  const [showShare, setShowShare] = useState<Boolean>(false);

  const handlePopupVideoMouseLeave = useMemo(
    () => () => {
      $(".popupVideo>.detail").hide();
    },
    []
  );
  
  const handleShowShareMouseLeave = useMemo(
    () => () => {
      setShowShare(false)
    },
    []
  );

  const shareCls = classNames('mr-1 share-BT', {'active': showShare})
  let likeCls = ''
  if (likesData && popup) {
    likeCls = classNames('mr-1', {'active': likesData[popup.id]})
  }
  return (
    <>
      <div className="popupVideo" onMouseLeave={handlePopupVideoMouseLeave}>
        <div className="detail">
          <div className="video-BG">
            <img onClick={() => {goToPage(`/ondemand/detail/${popup?.id}`, popup)}} src={popup?.thumb_list ? popup?.thumb_list.landscape_image: '/ondemand/static/img/default_channel.jpg'} alt="" />
          </div>
          <div className="txt">
            <h5>{popup?.title}</h5>
            <p className="inline-p">
              <img src="/ondemand/static/img/pop-video-sm.png" alt="" className="mr-1" />
              {displayDuration(popup?.duration)}
              <img src="/ondemand/static/img/pop-play-sm.png" alt="" className="ml-2 mr-1" />
              {displayNumber(popup?.count_views)}
              <img src="/ondemand/static/img/pop-like-sm.png" alt="" className="ml-2 mr-1" />
              {displayNumber(popup?.count_likes)}
            </p>
            <p className="inline-p">
              <img src="/ondemand/static/img/pop-sound-sm.png" alt="" className="mr-1" />
              Audio : {popup?.audio?.join(", ")} Subtitle :{" "}
              {popup?.subtitle?.join(", ")}
            </p>
            <div className="d-flex justify-content-between">
              <div className="form-button">
                <button onClick={() => {likes(popup?.id)}} className={likeCls}>
                  <img src="/ondemand/static/img/pop-like.png" alt="" />
                </button>
                
                <button className="mr-1">
                  <img src="/ondemand/static/img/pop-addbook.png" alt="" />
                </button>
                <button onClick={() => {setShowShare(true)}} className={shareCls}>
                  <img src="/ondemand/static/img/pop-share.png" alt="" />
                </button>
                {showShare && <div onMouseLeave={handleShowShareMouseLeave} className="sub-BT">
                  <button onClick={() => {share('https://www.facebook.com/sharer/sharer.php?u=', getContentUrl(popup))}}>
                      <img src="/ondemand/static/img/pop-Facebook.png" alt=""/>
                  </button>
                  <button onClick={() => {share('https://twitter.com/intent/tweet?text=', getContentUrl(popup))}}>
                      <img src="/ondemand/static/img/pop-Twitter.png" alt=""/>
                  </button>
                  <CopyToClipboard text={getContentUrl(popup)}>
                      <button>
                          <img src="/ondemand/static/img/pop-E-mail.png" alt=""/>
                      </button>
                  </CopyToClipboard>
                  
                  <button onClick={() => {share('https://social-plugins.line.me/lineit/share?url=', getContentUrl(popup))}}>
                      <img src="/ondemand/static/img/pop-line.png" alt=""/>
                  </button>
              </div>}
              </div>
              <button onClick={() => {window.location.href = getContentUrl(popup)}}>
                <img
                  src="/ondemand/static/img/pop-play.png"
                  alt=""
                  style={{ marginLeft: "3px" }}
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
